import { useState, forwardRef, useImperativeHandle } from 'react';
import { Input, message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import Utils from '@utils/utils';
import API from '@api/api';
import styles from './index.module.scss';

const ScheduleModel = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setScheduleVisible
    }));

    const [scheduleVisible, setScheduleVisible] = useState(false);
    const [contactName, setContactName] = useState('');
    const [mobile, setMobile] = useState('');
    const [mobileError, setMobileError] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const validateMobile = (value) => {
        const isValid = Utils.validateContact(value.trim());
        setMobileError(!isValid);
        return isValid;
    };

    const canSubmit = !!contactName.trim() && !!companyName.trim() && Utils.validateContact(mobile.trim());

    const handleSubmit = () => {
        if (submitting) return;
        if (!contactName.trim()) return message.warning('请输入联系人');
        if (!mobile.trim()) {
            setMobileError(true);
            return message.warning('请输入联系电话');
        }
        if (!validateMobile(mobile)) return message.warning('请输入正确的手机号');
        if (!companyName.trim()) return message.warning('请输入公司名称');

        setSubmitting(true);
        API.bookDemo({
            name: contactName.trim(),
            mobile: mobile.trim(),
            company: companyName.trim(),
        }).then((res) => {
            if (res.code == 0) {
                message.success('提交成功，我们会在24小时内联系您');
                setScheduleVisible(false);
                setContactName('');
                setMobile('');
                setMobileError(false);
                setCompanyName('');
            } else {
                message.warning(res.message || '提交失败，请稍后重试');
            }
        }).catch(() => {
            message.warning('提交失败，请稍后重试');
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const onCancel = () => {
        setScheduleVisible(false);
    };

    return (
        <PSAIModal
            title='预约演示'
            maxWidth={468}
            open={scheduleVisible}
            maskClosable={false}
            onCancel={onCancel}
            footer={null}
            zIndex={1002}
        >
            <div className={styles.ScheduleModel}>
                <p className={styles.Subtitle}>请填写以下信息，我们的资深顾问将在24小时内联系您</p>
                <div className={styles.FormRow}>
                    <span className={styles.Label}>联系人</span>
                    <Input
                        className={styles.Input}
                        placeholder='请输入您的称呼'
                        maxLength={30}
                        value={contactName}
                        onChange={(e) => setContactName(e.target.value)}
                    />
                </div>
                <div className={styles.FormRow}>
                    <span className={styles.Label}>联系电话</span>
                    <Input
                        className={`${styles.Input} ${mobileError ? styles.InputError : ''}`}
                        placeholder='请输入您的手机号'
                        maxLength={11}
                        value={mobile}
                        onChange={(e) => {
                            const nextValue = e.target.value;
                            setMobile(nextValue);
                            if (mobileError && Utils.validateContact(nextValue.trim())) {
                                setMobileError(false);
                            }
                        }}
                        onBlur={() => {
                            if (!mobile.trim()) {
                                setMobileError(false);
                                return;
                            }
                            validateMobile(mobile);
                        }}
                    />
                </div>
                <div className={styles.FormRow}>
                    <span className={styles.Label}>公司名称</span>
                    <Input
                        className={styles.Input}
                        placeholder='请输入您的公司名称'
                        maxLength={30}
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                    />
                </div>
                <button className={styles.SubmitButton} onClick={handleSubmit} disabled={!canSubmit || submitting}>{submitting ? '提交中...' : '提交预约'}</button>
                <p className={styles.PolicyText}>
                    点击提交即代表您同意我们的
                    <a href='/服务协议.htm' target='_blank' rel='noreferrer'> 服务条款 </a>
                    和
                    <a href='/隐私政策.htm' target='_blank' rel='noreferrer'> 隐私政策</a>
                </p>
            </div>
        </PSAIModal>
    );
});

export default ScheduleModel;